import axios from "axios";
import axiosRetry from "axios-retry";

const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY;

// Create axios instance with dynamic headers
const instance = axios.create({
  headers: {
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
    "Ocp-Apim-Subscription-Key": subscriptionKey,
  },
});

const getTokenFromLocalStorage = () => {
  return localStorage.getItem("token");
};

// Add a request interceptor to set the Authorization header with the Bearer token
instance.interceptors.request.use(
  (config) => {
    const token = getTokenFromLocalStorage();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['x-user-token'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // You can modify the request config here (e.g., add headers, authentication token, etc.)
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    // You can modify the response data here (e.g., transform data, handle success globally)
    return response;
  },
  (error) => {
    // Handle response error
    return Promise.reject(error);
  }
);

// Configure axios-retry
axiosRetry(instance, {
  retries: 3, // Number of retries
  retryDelay: (retryCount) => {
    return retryCount * 2000; // Time in ms (1 seconds)
  },
  retryCondition: (error) => {
    // Retry on network errors or 5xx status codes
    return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response.status >= 300;
  },
});

export default instance;
